<template>
    <div class="form-pref">
        <div class="aright mb-2">
            <CompassButton
                v-show="!edition"
                :label="$t.__('common.actions.edit')"
                type="secondary"
                @click="edition = true"
            />
            <CompassButton
                v-show="edition"
                :label="buttonTitle"
                type="primary"
                :loading="loading"
                @click="submitPeriods()"
            />
        </div>

        <table v-show="!edition" class="table with-vertical-line">
            <thead>
                <tr>
                    <th>{{ $l10n.__('Exercice') }}</th>
                    <th>{{ $l10n.__('Date de début') }}</th>
                    <th>{{ $l10n.__('Date de fin') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="year in years" :key="year.name">
                    <td>{{ year.name }}</td>
                    <td>{{ getLocalDate(year.period[0]) }}</td>
                    <td>{{ getLocalDate(year.period[1]) }}</td>
                </tr>
            </tbody>
        </table>

        <table v-show="edition" class="table with-vertical-line">
            <thead>
                <tr>
                    <th>{{ $l10n.__('Exercice') }}</th>
                    <th>{{ $l10n.__('Date de début') }}</th>
                    <th>{{ $l10n.__('Date de fin') }}</th>
                </tr>
            </thead>
            <tbody>
                <FiscalYearLine
                    v-for="(year, index) in years"
                    :key="year.name"
                    v-model="year.period"
                    :title="year.name"
                    :startError="getError(index, 'start')"
                    :endError="getError(index, 'end')"
                    :showDelete="index == years.length - 1"
                    @remove="delExercice"
                />
            </tbody>
        </table>

        <CompassButton
            v-show="edition"
            :label="$t.__('preferences.FiscalYear.add_fiscal_year')"
            type="tertiary"
            class="mr-2 mt-2"
            @click="addExercice()"
        />
    </div>
</template>

<script>
import FiscalYearLine from './FiscalYearLine.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('user');

export default {
    components: {
        FiscalYearLine,
    },
    props: {
        defaultYears: {
            required: true,
            type: Array,
        },
        transferInProgress: {
            required: true,
            type: Boolean,
        },
        fiscalEndDateFromPref: {
            required: true,
            type: String,
        },
    },

    data() {
        return {
            loading: this.transferInProgress,
            years: this.defaultYears,
            fieldErrors: {
                start: [],
                end: [],
            },
            edition: false,
        };
    },
    computed: {
        buttonTitle: function () {
            if (this.loading) {
                return this.$l10n.__('Transfert en cours, vous pouvez quitter la page');
            }
            return this.$l10n.__('Enregistrer');
        },
        ...mapState(['locale']),
    },
    methods: {
        getError(yearIndex, limit) {
            if (yearIndex in this.fieldErrors[limit]) {
                return this.fieldErrors[limit][yearIndex];
            }
            return null;
        },
        addExercice() {
            if (this.years.length == 0) {
                let dateFromPref = moment(this.fiscalEndDateFromPref);
                if (!dateFromPref.isValid()) {
                    dateFromPref = moment('1000-12-31');
                }
                dateFromPref.year(new Date().getFullYear());

                const end = dateFromPref.format('YYYY-MM-DD');
                const start = dateFromPref.subtract(1, 'years').add(1, 'days').format('YYYY-MM-DD');
                this.years.push({
                    name: 'N',
                    period: [start, end],
                });
                return;
            }

            const start = moment(this.years[this.years.length - 1].period[0]);
            const end = moment(this.years[this.years.length - 1].period[1]);

            this.years.push({
                name: 'N-' + this.years.length,
                period: [
                    start.subtract(1, 'years').format('YYYY-MM-DD'),
                    end.subtract(1, 'years').format('YYYY-MM-DD'),
                ],
            });
        },
        delExercice(name) {
            this.years = this.years.filter((year) => {
                return year.name != name;
            });
        },
        getLocalDate(formatedDate) {
            const date = moment(formatedDate);
            date.locale(this.locale);
            return date.format('LL');
        },
        submitPeriods() {
            // Reset field errors
            const fieldErrors = {
                start: [],
                end: [],
            };

            // Build option
            const options = {};
            this.years.forEach((year, index) => {
                options['fiscal_year_periodStart[' + index + ']'] = year.period[0];
                options['fiscal_year_periodEnd[' + index + ']'] = year.period[1];
            });

            $.post(
                '/?_f=companyPreferences&action=fiscalYearRecord',
                options,
                (data) => {
                    // Check error
                    if (data.form.status == 'failed') {
                        if (data.form.msg != '') {
                            Push.error(data.form.msg);
                        }

                        if (data.form.fields.length > 0) {
                            data.form.fields.forEach((error) => {
                                const fieldId = error.fieldId;
                                if (fieldId.match(/N\d+\-\d+/g)) {
                                    const year = fieldId.match(/(\d+)/g);
                                    fieldErrors['start'][year[0]] = error.msg;
                                    fieldErrors['end'][year[1]] = error.msg;
                                } else if (fieldId.match(/N\d+/g)) {
                                    const year = fieldId.match(/(\d+)/g);
                                    fieldErrors['start'][year] = error.msg;
                                    fieldErrors['end'][year] = error.msg;
                                } else {
                                    const born = fieldId.match(/(Start|End)/g)[0].toLowerCase();
                                    const year = fieldId.match(/(\d+)/g);

                                    fieldErrors[born][year] = error.msg;
                                }
                            });
                        }
                    } else {
                        Push.success(this.$l10n.__('Début du transfert'));
                        this.loading = true;
                    }
                    this.fieldErrors = fieldErrors;
                },
                'json',
            );
        },
    },
};
</script>
